// extracted by mini-css-extract-plugin
module.exports = {"linkGroup":"_3-6snpL3","isOpen":"_2Xsjem3E"};